export const getTransactionInfo = (dispatch: any, transactionId: string) =>
  dispatch({
    type: "GET_TRANSACTIONINFO",
    transactionId,
  });

export const getTransactionInfoSuccess = (data) => ({
  type: "GET_TRANSACTIONINFO_SUCCESS",
  data,
});

export const getTransactionInfoFailure = (error: Error) => ({
  type: "GET_TRANSACTIONINFO_FAILURE",
  error,
});
